import React from 'react';
import classNames from 'classnames';
import formatText from '../formatter';
import ellipsisStyles from '../ellipsis.scss';

function getTextElement(
  elementMapper,
  attributes,
  textStyles,
  props,
  ellipsis,
  ref
) {
  const { type, size, color, format } = attributes;

  let element = elementMapper[type];
  if (typeof element !== 'string') {
    element = element[size];
  }

  if (color) {
    textStyles.push(`color-${color}`);
  }

  if (ellipsis) {
    textStyles.push(ellipsisStyles.ellipsis);
  }

  if (format) {
    const c = props.children;
    if (typeof c === 'string') {
      const formattedText = formatText(format, c);
      props.children = formattedText.length > 0 ? formattedText : c;
    }
  }

  return React.createElement(element, {
    ...props,
    className: classNames(textStyles),
    ref
  });
}

export { getTextElement };
